import ApiService from "../services/api.service";

/**
 *
 * @type {{sw_categories: [], added: boolean, shops: [], update: boolean, import_status: boolean, token: boolean}}
 */
const state = {
    token: false,
    added: false,
    shops: [],
    update: false,
    sw_categories: [],
    import_status: false,
    delete_status: false,
}

/**
 *
 * @type {{SET_UPDATE(*, *): void, SET_TEST(*, *): void, ADD_SHOP(*, *): void, SET_SHOPS(*, *): void}}
 */
const mutations = {
    SET_TEST (state, payload) {
        state.token = payload
    },

    ADD_SHOP (sate, payload) {
        state.added = payload
    },

    SET_SHOPS (state, payload) {
        state.shops = payload.data.data
    },

    SET_UPDATE (state, payload) {
        state.update = payload
    },

    SET_CATEGORIES (state, payload) {
        state.sw_categories = payload.data.categories
    },

    SET_IMPORT_STATUS (state, payload) {
        state.import_status = payload
    },

    SET_DELETE_STATUS (state, payload) {
        state.delete_status = payload
    }
}

const actions = {
    /**
     * @param commit
     * @param state
     * @param data
     * @returns {Promise<void>}
     */
    async makeTest({ commit, state }, data) {
        await ApiService.post('shop/test', data).then(res => {
            if(res.data.access_token) {
                commit('SET_TEST', true)
            }
        }).catch(() => {
            commit('SET_TEST', false)
        })

    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     * @returns {Promise<void>}
     */
    async updateShop({ commit, state }, data) {
        await ApiService.put('shop/' + data.id, data).then(res => {
            if(res.data.status) {
                commit('SET_UPDATE', true)
            }
        }).catch(() => {
            commit('SET_UPDATE', false)
        })

    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     * @returns {Promise<void>}
     */
    async addShop({ commit, state}, data) {
        await ApiService.post('shop/create', data).then(res => {
            if(res.data.data.id) {
                commit('ADD_SHOP', true)
                commit('SET_TEST', true)
            } else {
                commit('SET_TEST', false)
            }

        }).catch(() => {
            commit('ADD_SHOP', false)
        })
    },

    /**
     *
     * @param commit
     * @param state
     * @param id
     * @returns {Promise<void>}
     */
    async loadShopById ({ commit, state }, id) {
        await ApiService.get('shop/' + id).then((data)=> {
            commit('SET_SHOP', data)
        })
    },


    /**
     *
     * @param commit
     * @param state
     * @param id
     * @returns {Promise<void>}
     */
    async loadShopwareCategories ({ commit, state }, id) {
        await ApiService.get('shops/' + id + '/categories').then((data)=> {
            commit('SET_CATEGORIES', data)
        })
    },

    /**
     *
     * @param commit
     * @param state
     * @returns {Promise<void>}
     */
    async loadShops ({ commit, state }) {
        await ApiService.get('shops').then((data)=> {
            commit('SET_SHOPS', data)
        })
    },

    /**
     *
     * @param commit
     * @param state
     * @param id
     * @returns {Promise<void>}
     */
    async doDelete ({ commit, state }, id) {
        await ApiService.delete('shop/' +id).then(res => {
            if(res.data.success === true) commit('SET_DELETE_STATUS', true)
            else commit('SET_DELETE_STATUS', false)
        }).catch(res => {
            commit('SET_DELETE_STATUS', false)
        })
    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     */
    async doImport ({ commit, state }, data) {
       await ApiService.post('shop/import',{ file_id: data.file_id, marge: data.marge}).then(res => {
           if(res.data.success === true) commit('SET_IMPORT_STATUS', true)
           else commit('SET_IMPORT_STATUS', false)
       }).catch(res => {
           commit('SET_IMPORT_STATUS', false)
       })
    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     */
    setAktiv ({ commit, state }, data) {
        ApiService.post('shop/active/' + data.id, { status: data.event})
    },
}

const getters = {

    getTest: state => state.token,

    getImportStatus: state => state.import_status,

    getDeleteStatus: state => state.delete_status,

    isShopAdded: state => state.added,

    getShops: state => state.shops,

    getShopwareCategories: state =>  Object.keys(state.sw_categories).map(k => state.sw_categories[k]),

    getUpdateStatus: state => state.update,

    getShopById: (state) => (id) => {
        return state.shops.find(shop => Number(shop.id) === Number(id))
    }
}

export const shop = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
